import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from 'seagull';
import { FilterChip } from '../FilterChip/FilterChip';
export const ToggleChip = (param)=>{
    let { testId, fieldLabel, valueLabel, tone, onToggle, onRemove, biPrefix } = param;
    return /*#__PURE__*/ _jsx(Box, {
        inline: true,
        children: /*#__PURE__*/ _jsx(FilterChip, {
            testId: testId,
            fieldLabel: fieldLabel,
            valueLabel: valueLabel,
            tone: tone,
            onValueClick: ()=>onToggle(),
            onFieldClick: ()=>onToggle(),
            onRemove: onRemove && (()=>onRemove()),
            removeBiName: "".concat(biPrefix, "_remove")
        })
    });
};
